<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitleFull }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    to="/newschedule"
                    tile
                    small
                    >
                        <v-icon dark>mdi-plus</v-icon>
                        Add New
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    tile
                    small
                    v-print="{ id: '#printMe', extraCss: 'https://api.mrpoolal.com/css/print.css', popTitle: 'Print Schedules', previewTitle: 'Print Schedules' }"
                    >
                        <v-icon dark class="mr-2">mdi-printer</v-icon>
                </v-btn>
                <v-btn
                    color="#ffffff"
                    class="primary--text"
                    @click="drawer = !drawer" 
                    tile
                    small
                    v-if="routeKey != 'new'"
                    >
                        Filter
                </v-btn>
            </v-toolbar>
            <v-toolbar
            color="#0c477c"
            dark
            flat
            height="40"
            >
                <v-spacer></v-spacer>
                <v-toolbar-title class="jobs-count" >
                     {{ total + ' Schedules Found.' }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
        </v-card>
        <v-card
            flat
            loader-height="10"
            tile
            min-width="100%"
        >
            <v-list two-line tile flat class="py-0 hover-list" id="printMe">
                <template v-for="(jobs, i) in groups">
                    <v-subheader class="jg-header text-uppercase" :key="`jgtitle-${i}`">{{ i }}</v-subheader>
                    <v-list-item-group :key="`jg-${i}`">
                        <template v-for="(job, index) in jobs">
                            <v-list-item
                            :key="`job-${index}`"
                            :value="job.id"                 
                            >
                                <template>
                                    <v-list-item-content @click.stop="openJob(job.id)">
                                        <v-list-item-title>{{ job.customer.street_address+ ', ' + job.customer.city + ', ' + job.customer.state + ' ' + job.customer.zip }}</v-list-item-title>
                                        <v-list-item-subtitle v-html="job.customer.title"></v-list-item-subtitle>
                                        <v-list-item-subtitle>Start Date: {{ job.job_start_date | moment('MMMM Do YYYY') }}<v-spacer></v-spacer>Next Date: {{ job.job_next_date | moment('MMMM Do YYYY') }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </template>
                            </v-list-item>
                            <v-divider
                            :key="`dv-${index}`"
                            ></v-divider>
                        </template>
                    </v-list-item-group>
                </template>  
                <v-list-item v-if="pagination.total > 1" id="paginationBar">
                    <v-list-item-content>
                        <v-pagination
                            v-model="pagination.current"
                            :length="pagination.total"
                            @input="onPageChange"
                            :total-visible="totalVisible"
                        ></v-pagination>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-card>
        <FilterJobs :show="drawer" :filter="filter" :routekey="routeKey" @update-status="updateStatus" @update-drawer="updateDrawer" @update-keyword="updateKeyword" @update-daterange="updateDaterange" @update-cleaner="updateCleaner" @submit-search="submitSearch"/>
    </v-container>
</template>

<script>
import axios from 'axios'
import FilterJobs from '../components/FilterSchedules.vue'
import print from 'vue-print-nb'

export default {
    data() {
        return {
            showmap: false,
            drawer: false,
            loading: true,
            downloadLoading: false,
            groups: [],
            pagination: {
                current: 1,
                total: 0
            },
            totalVisible: 5,
            pageTitle: '',
            apiUrl: '',
            routeKey: '',
            filter: {
                keyword: "",
                status: ["active", "completed"],
                daterange: "",
                cleaner: []
            },
            total: 0,
        }
    },
    directives: {
        print   
    },
    created() {
        this.pageTitle = this.$route.meta.title
        this.apiUrl = this.$route.meta.api
        this.routeKey = this.$route.meta.key
        this.getSchedules()
    },
    watch: {
        filter: {
            deep: true,

            handler(newValue) {
                this.$store.commit('SET_JOBS_FILTER', newValue)
            }
        }
    },
    computed: {
        pageTitleFull() {
            if(this.loading == true) {
                return 'Loading...'
            } else if(this.filter.status != 'all' && this.filter.cleaner != []) {
                //return this.filter.status.charAt(0).toUpperCase() + this.filter.status.slice(1) + ' Jobs'
                return this.pageTitle
            } else {
                return this.pageTitle
            }
        },
    },
    components: {
        FilterJobs,
    },
    methods: {
        getSchedules() {
            this.loading = true
            this.drawer = false
            if(this.$store.state.filter.schedule) {
                this.filter = this.$store.state.filter.schedule
            }
            
            axios.get(this.apiUrl + this.pagination.current, {
                params: this.filter
            })
            .then(response => {
                this.loading = false
                this.groups = response.data.groups
                this.markers = response.data.markers
                this.pagination.current = response.data.jobs.current_page
                this.pagination.total = response.data.jobs.last_page
                this.total = response.data.jobs.total
                this.all = response.data.all
                this.mapKey += 1
                this.$nextTick()
            })
        },
        onPageChange() {
            this.getSchedules()
            this.$vuetify.goTo(0)
        },
        openJob(id) {
            this.$router.push({ path: '/schedule/'+id })
        },
        dial (number) {
            window.location ='tel:'+number;
        },
        sendmail (address ){
            window.location = 'mailto:'+address;
        },
        googleLink (customer) {
            let link = 'https://www.google.com/maps?saddr=Current+Location&daddr=' + encodeURI(customer.street_address+ ', ' + customer.city + ', ' + customer.state + ' ' + customer.zip)
            window.open(link, "_blank") || window.location.replace(link)
        },
        updateDrawer(val) {
            this.drawer = val
        },
        updateKeyword(val) {
            this.filter.keyword = val
        },
        updateStatus(val) {
            this.filter.status = val
            this.getSchedules()
        },
        updateCleaner(val) {
            this.filter.cleaner = val
            this.getSchedules()
        },
        updateDaterange(val) {
            this.filter.daterange = val
        },
        submitSearch() {
            this.getSchedules()
        },
        getColor(status) {
            switch(status) {
                case 'completed':
                    return 'green'
                case 'active':
                    return 'light-blue'
                case 'cancelled':
                    return 'red'
                default:
                    // code block
            }
        },
    }
}
</script>
<style lang="sass" scoped>
.theme--light 
    .v-content
        background: #ffffff
.fullscreen
    background: #fff
    height: 100%
.w-100
    width: 100%
    .v-btn 
        width: 100%
.v-list-item__action
    .v-btn
        &:not(.v-btn--round)
            &.v-size--small
                height: 42px
.v-chip 
    border-radius: 0!important
.jobs-count
    font-size: 14px
.jg-header
    background: #1976d2
    color: #fff
    font-size: 18px
</style>